<div class="research-card" *ngFor="let card of researchCards;let i=index;">
    <div class="research-card-header" *ngIf="showEdit || showRemove">
        <button type="button" class="btn btn-sm mr-1" *ngIf="showEdit" (click)="editCard(card)">
            <img src="/pencil.svg" alt="Edit" />
        </button>
        <button type="button" class="btn btn-sm" *ngIf="showRemove" (click)="removeCard(i)">
            <img src="/cancel.svg" alt="Remove" />
        </button>
    </div>
    <div class="research-card-block scrollbar-white">
        <div class="card-item" *ngIf="card.title">
            <div class="label">Title</div>
            <div class="value">{{card.title}}</div>
        </div>
        <div class="card-item" *ngIf="card.title_de">
            <div class="label">Title (DE)</div>
            <div class="value">{{card.title_de}}</div>
        </div>
        <ng-container *ngIf="card.tags">
            <div class="card-item" *ngFor="let tag of card.tags">
                <div class="label">{{tag.popup}}</div>
                <div class="value">{{tag.text}}</div>
            </div>
        </ng-container>
        <div class="card-item" *ngIf="card.date">
            <div class="label">Date</div>
            <div class="value">{{card.date}}</div>
        </div>
        <div class="card-item" *ngIf="card.url">
            <div class="label">URL</div>
            <div class="value link">
                <a href="" [href]="card.url" target="_blank">{{card.url}}</a>
            </div>
        </div>
        <div class="card-item" *ngIf="card.abstract">
            <div class="label">Summary</div>
            <div class="value summary" [innerHTML]="card.abstract"></div>
        </div>
    </div>
</div>
